import { Constants } from '@helper/constants';
import { environment } from '../../environments/environment';

import { ClipboardService } from 'ngx-clipboard';

export class Share {
  private static getShareUrl(): string {
    return `${window.location.origin}${window.location.pathname}`;
  }

  static openFacebookLink(shareUrl = Share.getShareUrl()): void {
    window.open(
      `${Constants.SHARE_FACEBOOK_LINK}app_id=${environment.fbAppId}&display=popup&href=${encodeURI(shareUrl)}`
    );
  }

  static openMobileFacebookLink(shareUrl = Share.getShareUrl()): void {
    window.open(
      `${Constants.SHARE_FACEBOOK_LINK}app_id=${environment.fbAppId}&display=touch&href=${encodeURI(shareUrl)}`
    );
  }

  static openLineLink(title = '', shareUrl = Share.getShareUrl()): void {
    window.open(`${Constants.SHARE_LINE_LINK}${title} ${encodeURI(shareUrl)}`);
  }

  static copyLink(clipboardService: ClipboardService, shareUrl = Share.getShareUrl()): void {
    clipboardService.copy(shareUrl);
  }
}
